import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MenuComponent } from "./menu.component";
import { TransitionModule } from "../transition/index";
import { IconModule } from "../icon/icon.module";
import { RouterModule } from "@angular/router";
import { MenuItemComponent } from "./menu-item/menu-item.component";

@NgModule({
	declarations: [MenuComponent, MenuItemComponent],
	imports: [CommonModule, TransitionModule, IconModule, RouterModule],
	exports: [MenuComponent, MenuItemComponent]
})
export class MenuModule {}
